import { Preferences } from '@capacitor/preferences'
import { Capacitor } from '@capacitor/core'

const isNative = Capacitor.getPlatform() !== 'web'

async function restoreAllFromCapacitor() {
  console.log("saveToPerf restoreAll")
  const { keys } = await Preferences.keys()
  for (const key of keys) {
    const { value } = await Preferences.get({ key })
    if (value !== null) {
      console.log("saveToPerf restore", key, value)
      localStorage.setItem(key, value)
    }
  }
}

async function mirrorToCapacitor(key, value) {
  if (!isNative) return
  console.log("saveToPerf mirror d", key, value)
  if (value !== null) {
    console.log("saveToPerf mirror", key, value)
    await Preferences.set({ key, value })
  } else {
    await Preferences.remove({ key })
  }
}

function hookLocalStorage() {
  if (!isNative) return

  console.log("saveToPerf hook local storage")

  const originalSetItem = localStorage.setItem
  const originalRemoveItem = localStorage.removeItem
  const originalClear = localStorage.clear

  localStorage.setItem = function (key, value) {
    originalSetItem.apply(this, arguments)
    mirrorToCapacitor(key, value)
  }

  localStorage.removeItem = function (key) {
    originalRemoveItem.apply(this, arguments)
    mirrorToCapacitor(key, null)
  }

  localStorage.clear = function () {
    const keys = []
    for (let i = 0; i < localStorage.length; i++) {
      keys.push(localStorage.key(i))
    }
    originalClear.apply(this, arguments)
    keys.forEach((k) => mirrorToCapacitor(k, null))
  }
}

export async function initStorageSync() {
  if (!isNative) return

  if (localStorage.length === 0) {
    console.log("saveToPerf localStorage empty")
    await restoreAllFromCapacitor()
  }
  hookLocalStorage()
}
